export interface FlameDropProps {
  size?: number;
  className?: string;
}

/**
 * Llama/gota dorada de doble contorno con núcleo luminoso. En el mockup cuelga
 * del punto más bajo del arco del hero y hace de bisagra con el programa: sin
 * ella el arco se queda soso.
 */
export function FlameDrop({ size = 34, className }: FlameDropProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 32 48"
      width={size}
      height={(size * 48) / 32}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.1}
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M16 1.5C16 1.5 29.5 15.4 29.5 27.6 29.5 36.4 23.4 46.5 16 46.5 8.6 46.5 2.5 36.4 2.5 27.6 2.5 15.4 16 1.5 16 1.5Z" />
      <path d="M16 9.6C16 9.6 24.2 18.8 24.2 27.6 24.2 33.9 20.5 40.6 16 40.6 11.5 40.6 7.8 33.9 7.8 27.6 7.8 18.8 16 9.6 16 9.6Z" opacity="0.7" />
      <ellipse cx="16" cy="29.6" rx="3.4" ry="5.2" fill="currentColor" opacity="0.28" stroke="none" />
    </svg>
  );
}
